export default __webpack_public_path__ + "static/media/03.a9c4d0b7.jpg";